import React, {useContext, useRef, useState} from "react";
import TextM from "@common/components/text/TextM";
import ServerSearch from "../../../common/components/input/ServerSearch";
import {Dimensions, View} from "react-native";
import TitleM from "@common/components/text/TitleM";
import {ActivityIndicator, IconButton} from "react-native-paper";
import {useNavigation} from "@react-navigation/native";
import {theme} from "@common/theme/theme";
import {HeaderContainerM} from "@common/header/HeaderContainerM";
import {ScrollView} from "react-native-gesture-handler";
import {DimensionsContext, IS_WEB} from "@common/utils/mobileUtils";
import {connect} from "react-redux";
// import EditBillingModal from "./EditBillingModal";
import {apiIdle, apiRequest} from "@data/redux/actions/api";
// import ChangeStatusModal from "./ChangeStatusModal";
import {liveOccurrenceStatuses, roomTypes} from "@data/constants/formConstants";
import {AudioRecordingContainer} from "../../../student/activity/execute/AudioRecordingContainer";
import {MenuFilter} from "@common/components/menu/MenuFilter";
import LivesHistory from "@common/components/livesHistory/LivesHistory";
import { tutorsService } from '@data/services/tutorsService'
import IconButtonM from '@common/components/button/IconButtonM'
import { DialogM } from '@common/components/alert/dialog/Dialog'

const TutorLivesHistoryScreen = (props) => {
    const [urlParams, setUrlParams] = useState({});

    const navigation = useNavigation();

    const [formValues, setFormValues] = useState(null)

    const requestApiService = tutorsService.getTutorLiveOccurrences

    const urlParamsAdditional = {
        status: formValues?.status?.join(",") ?? ""
    }
    const onFinishSelecting = (newFormValues = null) => {
        if (newFormValues) {
            // console.log("newFormValues", newFormValues)
            // console.log("urlParams", urlParams)
            props.apiRequest(requestApiService, {}, {}, {
                ...urlParams,
                status: newFormValues?.status?.join(",") ?? ""
            })
        } else {
            // console.log("urlParams", urlParams)
            props.apiRequest(requestApiService, {}, {}, {...urlParams, ...urlParamsAdditional})
        }
    }

    // ** Filter options
    const filterItems = [
        {
            name: "status",
            label: "Statut",
            options: liveOccurrenceStatuses,
            defaultValue: []
        }
    ]

    const flatListRef = useRef();

    const dimensions = useContext(DimensionsContext);

    const columnHeight = 70


    const renderHeader = () => (
        <>
            <View style={{flexDirection: "row", alignItems: "center", marginRight: 20}}>
                <IconButton
                    icon={"times"}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    style={{
                        // position: "absolute",
                        marginRight: 10
                    }}
                    onPress={() => {
                        if (navigation.canGoBack()) navigation.goBack()
                        else navigation.replace("menu")
                    }}
                />
                <TitleM>Mon historique de lives</TitleM>
            </View>
            <View style={{flexDirection: "row", alignItems: "center"}}>
                {/*<MenuFilter style={{*/}
                {/*    alignItems: "space-between",*/}
                {/*    width: 300,*/}
                {/*    marginBottom: 10*/}
                {/*}}*/}
                {/*            setFormValues={setFormValues}*/}
                {/*            formValues={formValues}*/}
                {/*            filterItems={filterItems}*/}
                {/*            onFinishSelecting={onFinishSelecting}*/}
                {/*/>*/}
                <IconButtonM icon={"info"}
                             iconColor={theme.colors.white}
                             containerColor={theme.colors.primary}
                             style={{
                                 marginRight:5
                             }}
                             onPress={() => {
                                DialogM.show({
                                    text1: "Comment ça marche pour les paiements ?",
                                    text2: "Lorsqu'une séance est validée, le montant est transféré vers ton solde stripe. Tu peux alors suivre les virements automatiques depuis ton solde stripe vers ton compte bancaire, en cliquant sur 'SUIVRE MES PAIEMENTS' sur la page d'accueil.",
                                    // buttonText2: "Fermer"
                                })
                             }}
                             size={24}
                />
                <ServerSearch style={{
                    width: 240,
                    margin: 10
                }}
                              urlParams={urlParams}
                              setUrlParams={setUrlParams}
                              // setUrlParams={setUrlParams}
                />
            </View>
        </>
    );

    return (
        <View
            style={{
                alignSelf: "center",
                alignItems: "center",
                width: Dimensions.get("window").width,
                flex: 1
            }}
        >
            <HeaderContainerM
                style={{justifyContent: "space-between", width: "100%"}}
            >
                {dimensions?.width < 800 ? (
                    <ScrollView horizontal={true} style={{width: "100%"}}>
                        <View style={{flexDirection: "row"}}>{renderHeader()}</View>
                    </ScrollView>
                ) : (
                    <>{renderHeader()}</>
                )}
            </HeaderContainerM>
            <LivesHistory urlParams={urlParams} />
        </View>
    );
};
const mapDispatchToProps = {
    apiRequest,
    apiIdle
};

export default connect(null, mapDispatchToProps)(TutorLivesHistoryScreen);
